import { type ReactNode } from 'react';
import { css, styled } from 'styled-components';

const StyledDiv = styled.div<{
  $alignCenter?: boolean;
  visitorCanEdit: boolean;
}>`
  ${({ $alignCenter, theme, visitorCanEdit }) => css`
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 16px;
    text-align: left;
    justify-content: space-between;
    align-items: ${$alignCenter ? 'center' : 'flex-start'};
    gap: 8px;
    width: 100%;
    position: relative;
    border-radius: 4px;
    transition: background-color 125ms ease-in;

    padding: 8px 12px 8px 12px;
    gap: 10px;
    border-radius: 10px;
    // this negative margin + padding combo ensures we keep the actual content of this container left-aligned with the rest of the sidebar content,
    // while still keeping padding for the hover effect
    margin-left: -14px;
    margin-top: -8px;
    width: calc(100% + 24px);

    & > svg {
      opacity: 1;
      color: ${theme.colorsV2.gray60};
    }

    ${theme.mediaQueries.md} {
      & > svg {
        opacity: 0;
        transition: opacity 125ms ease-in;
        color: ${theme.colorsV2.gray60};
        ${$alignCenter
          ? css`
              margin-bottom: 1px;
            `
          : css`
              margin-top: 6px;
            `};
      }
    }

    ${visitorCanEdit
      ? css`
          &:hover,
          &:focus {
            background: ${theme.colorsV2.gray10};
            cursor: pointer;

            svg {
              opacity: 1;
            }
          }

          &:active {
            background: transparent;
          }
        `
      : css`
          cursor: auto;
        `}
  `}
`;

export const InlineEditContainer = ({
  alignCenter,
  children,
  label,
  onClick,
  visitorCanEdit,
  ...props
}: {
  readonly alignCenter?: boolean;
  readonly children: ReactNode;
  readonly label: string;
  readonly onClick: () => void;
  readonly visitorCanEdit: boolean;
}) => {
  return (
    <StyledDiv
      {...(visitorCanEdit
        ? {
            'aria-label': label,
            as: 'button',
            onClick,
            type: 'button',
          }
        : {})}
      $alignCenter={alignCenter}
      visitorCanEdit={visitorCanEdit}
      {...props}
    >
      {children}
    </StyledDiv>
  );
};
